import * as utils from "./misc.js";


export function init_tooltip() {


}
export function init() {


    init_tooltip();



    jQuery("*[data-vc-full-width]").addClass("vc_fullwidth");

    jQuery("*[data-href]").on("click", function () {
        var thisurl = jQuery(this).data("href");
        if (thisurl) {
            window.location = thisurl;
        }
    })

    jQuery(".logout").on("click", function () {
        logout();
    })

    jQuery(".showhide_button").on("click", function () {

        jQuery(this).siblings(".showhide_content").toggleClass("open");
        jQuery(this).toggleClass("open")
        if (jQuery(this).hasClass("open")) {
            jQuery(this).html("Read Less");
        }
        else {
            jQuery(this).html("Read More");
        }
    });

    jQuery(".container").on("click", ".gform_button.button[type='submit']", function () {
        jQuery(this).val("Please Wait...");
    })

    jQuery("*[data-scrollto]").on("click", function () {
        utils.scrollClick(this);
    });

    jQuery("form#commentform").attr('enctype', 'multipart/form-data');

    jQuery("input[name='myaddress']").on("blur", function () {

        var thisadd = jQuery(this).val();

        if (thisadd != "") {
            var googlekey = "AIzaSyDZz92zR7Wlxly-6PP0pGH5l7wqIS4u-LU"; // TODO: find out who owns this key
            googlekey = "";
            jQuery.get("https://maps.googleapis.com/maps/api/place/autocomplete/json?input=" + thisadd + "&types=geocode&key=" + googlekey,
                function (r) {

                    console.dir(r);

                    var r = JSON.parse(r);
                    if (r.r == "notfound") {
                        jQuery(".sendresetresult").html("Sorry, we couldn't find those details.");
                        emailfield.addClass("error");
                    }
                    else {
                        jQuery(".sendresetresult").html("Thanks. We have send you a reset email.");
                        jQuery(".sendresetform").hide();
                    }
                });
        }
    })
}
